import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IReturnItem } from '../../medtracs-entities/data.queries/returns/return-item';

@Component({
   selector: 'app-return-item-info-modal',
   templateUrl: './return-item-info-modal.component.html',
})
export class ReturnItemInfoModalComponent {
   @Input() item: IReturnItem | null = null;

   @ViewChild('modalTemplate', { static: true }) modalTemplate!: TemplateRef<any>;

   bsModalRef?: BsModalRef;

   close(): void {
      this.bsModalRef?.hide();
   }
}
